<template>
  <div>
    <div class="table-box setTable">
        <loading :isShow="listLoading" />
          <Table :columns="columns" :data="tableData">
            <template slot-scope="{ row }" slot="status">
              <span v-if="row.status == '1'">已承保</span>
              <span v-if="row.status == '-1'">已退保</span>
              <span v-if="row.status == '0'">已终止</span>
            </template>
            <template slot-scope="{ row }" slot="action">
              <span class="table-btn" @click="handlerPolicyDetail(row, 'isAbnormal')">详情</span>
              <span class="table-btn" @click="modifyPolicy('edit', row)">编辑</span>
              <span class="table-btn" @click="modifyPolicy('delete', row)">删除</span>
            </template>
          </Table>
        <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" v-if="tableData.length" />
        <!-- 线下保单详情 -->
        <policyDetail ref="policyDetailRef" :policyType="'anomaly'"></policyDetail>
      </div>
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import filters from "@/api/filter";
import policyDetail from "@/pages/orderManage/insuredOrder/components/policyDetail";
export default {
  mixins: [pageTool, common],
  components: {policyDetail},
  data(){
    return{
      columns:[
        {
          title: '保单号',
          key: 'policyNo',
          align: 'center',
          minWidth: 140
        },
        {
          title: '产品名称（产品编码）',
          key: 'productName',
          minWidth: 180,
          align: 'center',
          render(h, params) {
            return <span>{params.row.productName}({params.row.productCode})</span>;
          },
        },
        {
          title: '承保日期',
          key: 'insureTime',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            if(params.row.insureTime){
              const res = filters.filterTime(params.row.insureTime,"YYYY-MM-DD")
              return (
                <span>{res}</span>
              );
            }else{
              return (
                <span class="red">缺失</span>
              );
            }
            
          },
        },
        {
          title: '险种种类',
          key: 'themeName',
          align: 'center',
          minWidth: 140
        },
        {
          title: '保费（元）',
          key: 'fee',
          minWidth: 100,
          align: 'center',
        },
        {
          title: '保单状态',
          slot: 'status',
          minWidth: 100,
          align: 'center',
        },
        {
          title: '出单业务员',
          key: 'salesmanName',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            if(params.row.salesmanName){
              return (
                <span>{params.row.salesmanName}</span>
              );
            }else{
              return (
                <span class="red">缺失</span>
              );
            }
          },
        },
        {
          title: '投/被保险人',
          key: 'insuranceName',
          minWidth: 200,
          align: 'center',
          render(h, params) {
            if(params.row.insuranceName){
              const res = params.row.insuranceName
                ? params.row.holderName + "/" + params.row.insuranceName
                : params.row.holderName;
              return (
                  <div>{res}</div>
              );
            }else{
              return (
                <span class="red">缺失</span>
              );
            }
            
          },
        },
        {
          title: '操作',
          slot: 'action',
          width: 170,
          align: 'center',
          fixed:'right',
        },
      ],
      tableData:[],
      pageSize:5,
    }
  },
  mounted() {
    this.getList();
  },
  methods:{
    // 新增，编辑
    modifyPolicy(flag, row) {
      if (flag == "add") {
        sessionStorage.reloadPolicyData = '1';
        this.$router.push({
          path: "/orderManage/insuredOrder/addPolicy",
          query: { pageFlag: flag,
        workName:'workName' },
        });
      } else if (flag == "edit") {
        this.openPageTabTags(
          "/orderManage/insuredOrder/editPolicy/" + row.policyNo,
          {
            pageFlag: "edit",
            pageName: "policyManage",
            id: row.id,
            policyNo: row.policyNo,
            type: 'anomaly',
            workName:'workName'
          },
        );
      } else if (flag == "delete") {
        console.log(row);
        this.$Modal.confirm({
          title: "删除",
          content: "<p>确认删除操作?</p>",
          loading: true,
          onOk: () => {
            this.$http({
              url: `/buz/policyDraft/delete`,
              type: "GET",
              data: { id: row.id },
              apiPermissionCode : 'order_30_6'
            }).then((res) => {
              this.searchParams.pageNo = 1;
              this.getList();
              this.$Modal.remove();
              this.$Message.success("删除成功");
              this.$emit('getTab')
            }).catch(err => {
              this.$Modal.remove();
            });
          },
        });
      }
    },
    handlerPolicyDetail(row, type) {
      this.$refs["policyDetailRef"].open(row, type);
    },
    getList() {
      this.listLoading = true;
      this.$http({
        url: '/buz/policyAbnormal/read/list',
        type: 'post',
        data: {
          isAbnormal: "1",
          pageNo: this.pageNum,
          pageSize: this.pageSize,
        }
      })
        .then(res => {
          this.tableData = res.data;
          this.total = res.total;
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/.red {
    color: red;
  }
  .table-box{
  padding-bottom: 10px;
}
</style>